import { KontoausgleicheArt } from '@/domain/mitarbeiter/features/feiertagskonto/entities';
import z from 'zod';

export function useCreateKontoausgleichSchema() {
  const schema = z.object({
    art: z.enum(KontoausgleicheArt),
    datum: z.string().min(1, 'Feld darf nicht leer sein.'),
    bemerkung: z.string().optional(),
    tage: z
      .string()
      .regex(/^(?!0$)\d+(?:[.,]\d+)?$/, 'Feld darf nicht leer sein.'),
  });
  return schema;
}
